var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
import { useState } from 'react';
import { API_SEARCH_GLOBAL, API_GATEWAY } from '../helpers/api';
import { logger, loggerError, loggerOk } from '../helpers/Log';
import { maestroApiCall } from '../helpers/maestroDataSource';
import { MethodType } from '../helpers/createAPICall';
var getApiType = function (element, searchTerm, accountNumber) { return ({
    method: MethodType.GET,
    endpoint: "".concat(API_SEARCH_GLOBAL, "/").concat(element, "?$query=").concat(encodeURIComponent(searchTerm), "&number=").concat(accountNumber, "&$limit=100"),
    baseURL: API_GATEWAY,
}); };
export var useSearchGlobal = function () {
    var _a = __read(useState({}), 2), abortControllers = _a[0], setAbortControllers = _a[1];
    function searchGlobal(_a) {
        var searchTerm = _a.searchTerm, accountNumber = _a.accountNumber, itemsToSearch = _a.itemsToSearch;
        return __awaiter(this, void 0, void 0, function () {
            var promises_1, results, error_1;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        logger('requesting global search: ', searchTerm);
                        _b.label = 1;
                    case 1:
                        _b.trys.push([1, 3, , 4]);
                        promises_1 = [];
                        itemsToSearch.forEach(function (item) {
                            var _a;
                            if (abortControllers[item]) {
                                abortControllers[item].abort();
                            }
                            var abortController = new AbortController();
                            abortControllers[item] = abortController;
                            setAbortControllers(__assign(__assign({}, abortControllers), (_a = {}, _a[item] = abortController, _a)));
                            promises_1.push(maestroApiCall(getApiType(item, searchTerm, accountNumber), {}, abortController).then(function (res) {
                                var _a;
                                return (_a = {}, _a[item] = res.data, _a);
                            }));
                        });
                        return [4 /*yield*/, Promise.all(promises_1).then(function (responses) {
                                setAbortControllers({});
                                var response = {};
                                responses.forEach(function (res) {
                                    response = __assign(__assign({}, response), res);
                                });
                                return response;
                            })];
                    case 2:
                        results = _b.sent();
                        loggerOk('success global search', results);
                        return [2 /*return*/, results];
                    case 3:
                        error_1 = _b.sent();
                        loggerError('fail global search');
                        loggerError(error_1);
                        return [2 /*return*/, {}];
                    case 4: return [2 /*return*/];
                }
            });
        });
    }
    return {
        searchGlobal: searchGlobal,
        loading: Object.keys(abortControllers).length > 0,
    };
};
//# sourceMappingURL=useSearchGlobal.js.map